import { render } from "./WalletView.vue?vue&type=template&id=48ee19f8"
import script from "./WalletView.vue?vue&type=script&lang=js"
export * from "./WalletView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__